import React, { FC, useState } from 'react';
import { ArrowGrey } from '../Arrows/Arrows';
import clsx from 'clsx';
import { trackEvent } from '../../analytics/gtm';
import { isMobile } from 'react-device-detect';
import i18n from '../../common/i18n';

const LI_CLASS = 'c-default px-3 py-2';

const ImportantInfo: FC<{ trackClick?: boolean; otherClass?: string }> = ({ trackClick = false, otherClass }) => {
    const [expanded, setExpanded] = useState(false);
    const toggleContent = () => {
        setExpanded(!expanded);
        if (trackClick) {
            trackEvent('Nikeone', !expanded ? 'Show InfoPanel' : 'Hide InfoPanel');
        }
    };
    const headerCmsKey = `nui.bettingInfo.header${isMobile ? '.mobile' : ''}`;
    return (
        <>
            <button
                onClick={toggleContent}
                className={clsx('important-info flex items-center my-10 hover-bgr px-8', otherClass)}
                data-atid="importatnt-info-button-live-bet"
            >
                <ArrowGrey
                    otherClassName={`c-black-40 ${expanded ? '' : ' arrow-right'}`}
                    dataAtid="important-info-arrow-live-bet"
                />
                <span className="uppercase c-default fs-13 ml-8" data-atid="important-info-title-live-bet">
                    {i18n(headerCmsKey)}
                </span>
            </button>
            <ul
                className={clsx('mx-10 mt-3 c-black-60 pl-15 fs-13 lh-20', {
                    hide: !expanded
                })}
                data-atid="important-info-text-live-bet"
            >
                <li className={LI_CLASS}>{i18n('nui.bettingInfo.line2')}</li>
                <li className={LI_CLASS}>{i18n('nui.bettingInfo.line3')}</li>
            </ul>
        </>
    );
};

export default ImportantInfo;
